import { t } from "../../../../../../utils/i18n";
import React, { useState } from "react";
import { CardType } from "../../Types";
import CouponModal from "../CouponModal";
import plasticBlack from "../../../../../../../assets/images/plastic_black.png";
import metalSilver from "../../../../../../../assets/images/metal_silver.png";
import metalGold from "../../../../../../../assets/images/metal_gold.png";
import metalBlack from "../../../../../../../assets/images/metal_black.png";

interface Props {
  cardType: CardType;
  onClickCardType: (e: any, cardType: CardType) => void;
  handleTooltipClick: (title: string) => void;
  updateCouponCode: (couponCode: string) => void;
}

const CardDetail: React.FC<Props> = ({
  cardType,
  onClickCardType,
  handleTooltipClick,
  updateCouponCode,
}) => {
  const [redeemCoupon, setRedeemCoupon] = useState<boolean>(false);
  const [discountedFee, setDiscountedFee] = useState(null);
  const [claimable, setClaimable] = useState(false);

  const onClickRedeemCoupon = (e: any) => {
    e.preventDefault();
    setRedeemCoupon(true);
  };

  const cardTypeImages: { [key: string]: string } = {
    Plastic: `${plasticBlack}`,
    "Metal Silver": `${metalSilver}`,
    "Metal Gold": `${metalGold}`,
    "Metal Black": `${metalBlack}`,
    Virtual: `${plasticBlack}`,
  };

  const honorCouponRedeemSuccess = (response: any) => {
    cardType.discounted_fee = response.discounted_fee;
    cardType.coupon_code = response.coupon_code;
    cardType.is_coupon_claimable = true;
    setDiscountedFee(response.discounted_fee);
    setClaimable(true);
    setRedeemCoupon(false);
    updateCouponCode(response.coupon_code);
  };

  const isPlasticCard = ["Plastic", "Virtual"].includes(cardType.name);
  const title =
    cardType.type === "virtual"
      ? t("cards.request_form.total_cost_virtual")
      : t("cards.request_form.total_cost_physical");

  return (
    <>
      <div
        className={`card-main-details text-center ${
          isPlasticCard ? "plastic-card-layout" : ""
        }`}
      >
        <img
          src={cardTypeImages[cardType.name]}
          alt={t("cards.request_form.bc_debit_card")}
          className={`card-img ${isPlasticCard ? "plastic-card-img" : ""}`}
        />
        <div
          className={`card-text-content ${
            isPlasticCard ? "plastic-card-text" : ""
          }`}
        >
          <div className="card-name mt-2">{cardType.name}</div>
          <div className="card-fee">
            {claimable ? (
              <>${discountedFee}</>
            ) : (
              <>${cardType.application_fee} </>
            )}
            <i
              className="fa fa-info-circle card-fee-info"
              aria-hidden="true"
              title={title}
              onClick={(e) =>
                handleTooltipClick(e.currentTarget.getAttribute("title") || "")
              }
            ></i>
            {cardType.coupon_code && (
              <p style={{ fontSize: "14px", margin: "0" }}>
                {t("cards.request_form.coupon", { code: cardType.coupon_code })}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="card-other-details" style={{ width: "100%" }}>
        <button
          className="select-button mb-3"
          onClick={(e) => onClickCardType(e, cardType)}
        >
          {t("cards.request_form.get_started")} <i className="fa fa-long-arrow-right"></i>
        </button>
        <div>
          <a
            href="#"
            className="cards-coupon"
            onClick={(e) => onClickRedeemCoupon(e)}
          >
            <i className="fas fa-angle-right"></i> {t("cards.request_form.redeem_coupon")}{" "}
            <i className="fas fa-tags"></i>
          </a>
        </div>
        <br />
        <ul>
          <li>
            <i
              className="fa fa-info-circle cards-info-icons"
              aria-hidden="true"
              title={t("cards.request_form.account_load_fee_is_incurred_in")}
              onClick={(e) =>
                handleTooltipClick(e.currentTarget.getAttribute("title") || "")
              }
            ></i>
            <span>
              {t("cards.request_form.loading_fee")}{" "}
              <span className="card-details-data">{cardType.loading_fee}%</span>
            </span>
          </li>
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.conversion_of_crypto_to_fiat_rates")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {t("cards.request_form.conversion_fee")}{" "}
                <span className="card-details-data">
                  {cardType.conversion_fee}%
                </span>
              </span>
            </li>
          )}
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.fee_charged_to_replace_card")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {" "}
                {t("cards.request_form.lost_card_replacement_fee")}{" "}
                <span className="card-details-data">
                  ${cardType.replacement_fee}
                </span>
              </span>
            </li>
          )}
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.fee_charged_annually_for_card_maintenance")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {" "}
                {t("cards.request_form.annual_maintenance_fee")}{" "}
                <span className="card-details-data">
                  ${cardType.yearly_maintenance_fee}
                </span>
              </span>
            </li>
          )}
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.fee_charged_by_atms_upon_withdrawal")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {t("cards.request_form.atm_withdrawal_fee")}{" "}
                <span className="card-details-data">
                  {cardType.atm_withdrawal_fee}%
                </span>
              </span>
            </li>
          )}
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.fee_charged_by_atms_to_check")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {t("cards.request_form.atm_check_balance_fee")}{" "}
                <span className="card-details-data">
                  {cardType.check_balance_fee_atm}
                </span>
              </span>
            </li>
          )}
          {cardType.type !== "virtual" && (
            <li>
              <i
                className="fa fa-info-circle cards-info-icons"
                aria-hidden="true"
                title={t("cards.request_form.fee_charged_for_use_of_cards")}
                onClick={(e) =>
                  handleTooltipClick(
                    e.currentTarget.getAttribute("title") || ""
                  )
                }
              ></i>
              <span>
                {" "}
                {t("cards.request_form.pos_online_fee")}{" "}
                <span className="card-details-data">
                  {cardType.pos_online_fee}%
                </span>
              </span>{" "}
            </li>
          )}
          <li>
            <i
              className="fa fa-info-circle cards-info-icons"
              aria-hidden="true"
              title={t("cards.request_form.maximum_amount_card_can_be_credited")}
              onClick={(e) =>
                handleTooltipClick(e.currentTarget.getAttribute("title") || "")
              }
            ></i>
            <span>
              {" "}
              <strong>{t("cards.request_form.monthly_spend_cap")}</strong>
              <span className="card-details-data">
                {cardType.loading_cap_monthly}
              </span>
            </span>{" "}
          </li>
        </ul>
        <CouponModal
          cardType={cardType.type}
          showCouponModal={redeemCoupon}
          handleShowCouponModal={setRedeemCoupon}
          honorCouponRedeemSuccess={honorCouponRedeemSuccess}
        />
      </div>
    </>
  );
};

export default CardDetail;
